import React from 'react';
import { usePopup } from '../../context/PopupContext';
import "../../assets/scss/common/_confirmationbox.scss";
const ConfirmationPopup = (props) => {
    const {boxContent, close, status, rightCallbackAction, leftCallbackAction } =  usePopup();
    // configurePopup('confirmbox', {
    //     heading: 'Message',
    //     content: 'Please confirm your action',
    //     confirmationButtontText: 'ok',
    //     cancelButtonText: 'cancel'
    // })
    return (<>
        {status('confirmbox') && <><div className="transparent-popup-bg"></div>
        <div className="custom-skip-popup">
            <div className="close-btn-icon">
                <button
                    className="close-icon test-close"
                    onClick={close}>Close</button>
            </div>
            <div className="content-box">
                <h4>{boxContent.heading}</h4>
                <p>{boxContent.content}</p>
                <div className="button-area">
                    <button className="no-skip" onClick={leftCallbackAction}>{boxContent.cancelButtonText}</button>
                    <button className="skip" onClick={rightCallbackAction}>{boxContent.confirmButtonText}</button>
                </div>
            </div>
        </div></>}
    </>)
}
export default ConfirmationPopup;

